// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"339":"1d45bcaa","787":"11313f1a","808":"c5c445b6"}[chunkId] + ".chunk.js";
};